import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { GachaModalService } from '../../services/gacha-modal.service';
import { MobileScaleService } from '../../services/mobile-scale.service';
import { OnchainStateService } from '../../services/onchain-state.service';

@Component({
  selector: 'app-gacha-cta-strip',
  templateUrl: './gacha-cta-strip.component.html',
  styleUrls: [
    './gacha-cta-strip.component.css',
    './gacha-cta-strip.component.mobile.css',
  ],
  host: { '[class.hidden]': '!visible()' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GachaCtaStripComponent {
  private readonly onchainState = inject(OnchainStateService);
  protected readonly gachaModal = inject(GachaModalService);
  protected readonly mobile = inject(MobileScaleService);

  protected readonly pointsBalance = this.onchainState.pointsBalance;
  protected readonly rollCost = this.onchainState.rollCost;

  protected readonly visible = computed(
    () => this.gachaModal.canAffordRoll() && !this.gachaModal.isSoldOut(),
  );

  constructor() {
    // Affordability can't be judged until the cost is known, and opening the
    // modal is otherwise the only thing that reads it.
    this.gachaModal
      .ensureRollCost()
      .catch((err) => console.error('failed to read gacha roll cost', err));
  }
}
